import { Stack } from '@mui/material'
import { ComponentFinder } from '../componentFinder'
import { IComponent } from '@eventr/common'

interface ISpaceBetweenProps {
    data: any
    renderOptions: ISpaceBetweenRenderOptions
    past?: boolean
}
interface ISpaceBetweenRenderOptions {
    components: IComponent[]
    direction?: 'row' | 'column'
    alignItems?: 'center' | 'flex-start' | 'flex-end'
}

export const SpaceBetween = ({
    data,
    renderOptions,
    past,
}: ISpaceBetweenProps) => {
    return (
        <>
            {renderOptions.components && data && (
                <Stack
                    alignItems={renderOptions.alignItems ?? 'flex-start'}
                    direction={renderOptions.direction ?? 'row'}
                    justifyContent="space-between"
                >
                    {renderOptions.components.map((c, i) => {
                        return (
                            <ComponentFinder
                                key={'finder_' + c.componentKey + i}
                                data={data}
                                renderOptions={c}
                                componentKey={c.componentKey}
                                isInPast={past}
                            />
                        )
                    })}
                </Stack>
            )}
        </>
    )
}
